import LocalityTable from "../../../views/Locality";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const localityRoutes = [
  {
    path: "/localities",
    component: LocalityTable,
    exact: true,
    menuName: MenuNames.LOCALITY,
  },
  {
    menuName: MenuNames.LOCALITY,
    path: "/localities/:id(\\d+)",
    component: LocalityTable,
    exact: true,
  },
];

export default localityRoutes;
